import {Injectable} from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService extends BaseService {
  private url = "api/before-login";
  private checkUrl = 'api/user/checkPsw';
  private passwordLengthUrl = 'api/system-config/passwordLength';

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl() {
    return this.url;
  }

  sendEmail(object:any):Observable<any> {
    return this.http.post<any>('api/before-login/password-reset-by-login?_allow_anonymous=true', object, httpOptions).pipe(
      tap((object:any) => this.log(`sendEmail`)),
      catchError(this.handleError<any>('sendEmail'))
    );
  }

  //根据手机号发送邮件
  sendEmailByPhone(object:any):Observable<any> {
    return this.http.post<any>('api/before-login/password-reset-by-phone?_allow_anonymous=true', object, httpOptions).pipe(
      tap((object:any) => this.log(`sendEmailByPhone`)),
      catchError(this.handleError<any>('sendEmailByPhone'))
    );
  }

  resetCheck(obj):Observable<any> {
    return this.http.get(this.url + '/reset-check?_allow_anonymous=true',
      {
        headers: httpOptions.headers,
        params: obj
      }
    ).pipe(
      tap(() => this.log('resetCheck')),
      catchError(this.handleError('resetCheck'))
    );
  }

  resetPassword(obj):Observable<any> {
    return this.http.post(this.url + '/reset-password?_allow_anonymous=true', obj
    ).pipe(
      tap(() => this.log('resetCheck')),
      catchError(this.handleError('resetCheck'))
    );
  }

  checkPassword(str):Observable<any> {
    return this.http.put<any>(this.checkUrl + '?_allow_anonymous=true', str).pipe(
      tap((object:any) => this.log(`save-draft`)),
      catchError(this.handleError<any>('save-draft'))
    );
  }

  getPasswordLength():Observable<any> {
    return this.http.get<any>(this.passwordLengthUrl + '?_allow_anonymous=true').pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }
}
